import { render, staticRenderFns } from "./introduction-case.vue?vue&type=template&id=355c004a"
import script from "./introduction-case.vue?vue&type=script&lang=ts"
export * from "./introduction-case.vue?vue&type=script&lang=ts"
import style0 from "./introduction-case.vue?vue&type=style&index=0&id=355c004a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports